import { render, staticRenderFns } from "./ListFormItem.vue?vue&type=template&id=0db17467&"
import script from "./ListFormItem.vue?vue&type=script&lang=js&"
export * from "./ListFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports